import ReportForm from '../../ReportForm';

const AddEditItemComboSalesReport = () => (
  <ReportForm bucket="itemComboSalesReports" />
);

export default AddEditItemComboSalesReport;
